export default __webpack_public_path__ + "static/media/Christmas_39.9a34ebd7.png";